<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="店铺名称" v-if="stoId==0" class='tiny'>
						<el-input style="width:200px;" v-model="orderInfo.storeName" placeholder="请输入店铺名称">
						</el-input>
					</el-form-item>
					<el-form-item label="员工手机号" class='tiny'>
						<el-input style="width:200px;" v-model="orderInfo.phone" placeholder="请输入员工手机号">
						</el-input>
					</el-form-item>
					<el-form-item label="状态" class='tiny'>
						<el-select v-model="orderInfo.status"  style="width: 100px;">
							<el-option key="-1" label="全部" value="">全部</el-option>
							<el-option value="true" label="启用">启用</el-option>
							<el-option value="false" label="停用">停用</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否开启级别" class='tiny'>
						<el-select v-model="orderInfo.isLevel" style="width: 100px;">
							<el-option key="-1" label="全部" value="">全部</el-option>
							<el-option value="true" label="是">是</el-option>
							<el-option value="false" label="否">否</el-option>
						</el-select>
					</el-form-item>
					
					
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button type="primary" @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<el-button v-if="stoId!=0" type="primary" @click="editialogVisible()">新增人员岗位</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%">
			
			
			<el-table-column prop="storeName" v-if="stoId==0"  label="店铺名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="username"  label="员工名" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="phone"  label="员工手机号" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="jobTitle"  label="岗位" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="isLevel" label="是否开启级别" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.isLevel==true">是</span>
					<span v-if="scope.row.isLevel==false">否</span>
				</template>
			</el-table-column>
			<el-table-column prop="levelName" label="级别名称" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					{{scope.row.levelName?scope.row.levelName:'暂未开启'}}
				</template>
			</el-table-column>
			
			
			<el-table-column prop="status" label="状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.status==true">启用</span>
					<span v-if="scope.row.status==false">停用</span>
				</template>
			</el-table-column>
			<el-table-column prop="createBy" label="新增操作人" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
		
			<el-table-column prop="createDate" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateDate" label="更新时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="" label="操作"  fixed="right"    align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					<el-button  size="small" v-if="!scope.row.status" type="text" @click="glstatus(scope.row.id,1)">启用</el-button>　
					<el-button style="color: red;" size="small" v-else type="text" @click="glstatus(scope.row.id,2)">停用</el-button>　　　
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" :title="title" @close="addDialogClose"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<el-form-item  label="用户名称"   style="width: 400px;">
						
						<el-select filterable v-if="title == '新增人员岗位'"  v-model="storeGoodsInfo.userId" class="big" placeholder="请输入用户名称后选择用户" clear 
							:remote-method="getUserList"
							:loading="storeLoading"
							remote
							reserve-keyword
							style="width:100%">
							<el-option v-for="item in accountList" :key="item.id" :value="item.id" :label="item.username">
								用户名：{{item.username}}   -   手机号：{{item.phone}}
							</el-option>
						</el-select>
						<el-input v-else disabled type="text" style="width: 225px;;" v-model="username"
							auto-complete="off"  />
					</el-form-item>
					
						<el-form-item label="店铺名称" v-if="title=='编辑人员岗位'&&stoId==0">
							<el-input disabled type="text" style="width: 200px; margin-left:25px ;" v-model="storeGoodsInfo.storeName"
								auto-complete="off" placeholder="请输入店铺名称" />
						</el-form-item>
						
						
						<el-form-item label="选择岗位">
							<el-select v-model="storeGoodsInfo.jobId" @change="change">
									
							<el-option v-for="item in KxList" :key="item.id" :value="item.id" :label="item.name">{{item.name}}</el-option>
								
							</el-select>
						
						</el-form-item>
						<!-- <el-form-item label="是否开启级别" v-if="title == '新增人员岗位'">
							<el-switch disabled v-model="sInfo.isLevel" :active-value="true" :inactive-value="false"
								class="switchss">
							</el-switch>
						</el-form-item> -->
						
						<el-form-item label="选择级别"  v-if="sInfo.isLevel">
							<el-select v-model="storeGoodsInfo.jobLevelId">
									
							<el-option v-for="item in jbList" :key="item.id" :value="item.id" :label="item.name">{{item.name}}</el-option>
								
							</el-select>
						
						</el-form-item>
					<!-- <el-form-item label="是否默认开人员岗位" class="redItem">
						<el-switch v-model="sInfo.isDefault" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item> -->
					<div style="display: flex;justify-content: space-between;">
						
						<el-form-item label="赠送数量" v-if="sInfo.isRewardIntegral" class="redItem">
							赠送{{sInfo.rewardIntegralNum}}{{sInfo.integralName}}
						</el-form-item>
					</div>
					
					<el-button type="primary" v-if="title=='新增人员岗位'" @click="sure" style="margin-top: 100px;">提交</el-button>
					<el-button type="primary" v-else @click="submit" style="margin-top: 100px;">编辑</el-button>
				</el-form>
			</div>
		</el-dialog>
		<!-- 编辑修改 -->
		
	</div>
</template>

<script>
	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('job');
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				userList:[],
				sInfo:{},
				storeLoading:false,
				accountList:[],
				stoId:'',
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				tableData:[
					{
						levelName:'',
						orderIndex:'',
						status:false
					}
				],
				sliderlist:{},
				expressList: [],
				orderInfo: {
					status: '',
					isLevel: '',
				},
				storeGoodsInfo: {
					isRewardIntegral:false,
					isRepeat:false,
					isDefault:false,
					isCardTimes:false
				},
				dialogVisibleSwiper: false,
				dialogVisibleSwipers: false,
				title:'',
				KxList:[],
				dialogImageUrl:'',
				httpUrl: urls,
				httpUrl1: urls,
				fileList: [],
				fileList1: [],
				jbList:[],
				username:'',
				goodsImages:[],
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				}
			}
		},
		methods: {
			sure(){
				
				this.$api.adderpJobUser({...this.storeGoodsInfo,isLevel:this.sInfo.isLevel}).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.pmsbrdselect()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {
							}
					} else {
						this.$message.error(res.message);
					}
				})
			},
			del(it){
				this.tableData.splice(it,1)
				
			},
			add(){
				this.tableData.push({
					levelName:'',
					orderIndex:'',
					status:false
				})
			},
			addDialogClose(){
				this.dialogVisibleSwiper=false
			},
		
			search() { //查询
					
				this.pmsbrdselect()

			},
			empty() { //清空
				this.orderInfo = {}
				this.page.pageNum=1
			},
			
			pmsbrdselect() {
				let data = {
					 pageNum: this.page.pageNum,
					 pageSize: this.page.pageSize,
					...this.orderInfo
				}
				this.$api.erpJobUser(data).then((res) => {
					console.log(res)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			// 新增
		

			// 提交
			submit() {
			
				let data = this.storeGoodsInfo
				console.log(data)
				this.$api.editerpJobUser(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.pmsbrdselect()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {
						}
					} else {
						this.$message.error(res.message);
					}
				})

			},
			getUserList(e) {
				this.storeLoading = true
				//查询用户账号
				if (e.length >= 2) {
					var data = {
						queryParam: e,
						pageNum: 1,
						pageSize: 20,
					}
					this.$api.queryManageUserWhere(data).then((res) => {
						console.log(res,123456);
						if (res.state == 'success') {
							if (res.data && res.data.list.length) {
								// this.$message({
								// 	message: '查询成功，请选择用户！',
								// 	type: 'success'
								// });
								this.accountList = res.data.list
							} else {
								this.accountList=[]
								this.$message.error("未查询到用户");
							}
						}else{
							this.$message.error(res.message);
						}
						this.storeLoading = false
					})
				}else{
					this.accountList = []
				}
			},
			// 编辑
			editialogVisible(e) {
				this.dialogVisibleSwiper=true
				if(e){
					
					this.title='编辑人员岗位'
					this.$api.findByIderpJobLevel(e).then((res) => {
						if (res.state == 'success') {
							
							this.storeGoodsInfo = res.data
							this.username=res.data.username
							this.$api.erpJobLevel(res.data.jobId).then(res=>{
								console.log(res.data);
								if(res.data.length>0){
									this.jbList=res.data
									this.sInfo=this.storeGoodsInfo
								
								}else{
									this.sInfo.isLevel=false
								}
							})
							
							this.dialogVisibleSwipers = true
					
						}
					})
				}else{
					this.title='新增人员岗位'
					this.storeGoodsInfo = {
					
					}
					
				}
				
				
			
				
			},
			glstatus(e,type){
				if(type==2){
					var str = "此操作将停用该人员岗位, 是否继续?"
				}else{
					var str = "此操作将启用该人员岗位, 是否继续?"
				}
				
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(e)
					this.$api.statusIderpJobLevel(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.pmsbrdselect();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			change(e){
				
				this.sInfo=this.KxList.find(item=>item.id==e)
				
				this.$api.erpJobLevel(e).then(res=>{
					this.jbList=res.data
					this.storeGoodsInfo.jobLevelId=res.data[0].id
				})
			},
			// 删除
			toDelete(e) {
				console.log(e)
				var str = "此操作将删除该人员岗位, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(e)
					this.$api.delIderpJobLevel(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.pmsbrdselect();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.pmsbrdselect();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.pmsbrdselect()
			},
		},




		created() {
			
			this.pmsbrdselect()
			this.$api.getUserInfo(this.$encrypt({})).then(res => {
				res.data = JSON.parse(this.$decrypt(res.data)).data
				if (res.state == 'success') {
					// console.log('登录人信息---', res.data )
					// supplierId(有值就是供应商)
					this.stoId = res.data.storeId; // storeId：0(平台)   
					
				}
			})
			this.$api.geterpJob().then(res=>{
				
				this.KxList=res.data
			})
			
			
		}
	}
</script>

<style>

</style>
